import { Flex } from "@chakra-ui/react";
import Hero from "./components/hero/Hero";
import Projects from "../../components/projects/Projects";
import Skills from "../../components/skills/Skills";
import Services from "./components/services/Services";
import About from "../../components/about/About";
import GetInTouch from "./components/get-in-touch/GetInTouch";
import Clients from "../../components/clients/Clients";
// import Blogs from "../../components/blogs/Blogs";

const HomePage = (): JSX.Element => {
  return (
    <Flex direction={"column"} alignItems={"center"} gap={100}>
      <Flex
        width={"full"}
        minHeight={"calc(100vh - 100px)"}
        alignItems={"center"}
      >
        <Hero />
      </Flex>

      <About />
      <Services />
      <Clients />
      <Projects />
      <Skills />
      {/* <Blogs /> */}
      <GetInTouch />
    </Flex>
  );
};

export default HomePage;
